import { createContext } from 'react';
import { ILineEditContext } from './LineEditContext.types';

export const LineEditContext = createContext<ILineEditContext>({
    current: 0,
    setCurrent: () => {}
});
